module.exports = __webpack_public_path__ + "static/media/Surrendering.50cfacb6.png";